module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete":"Delete this option","up":"Move this option up","down":"Move this option down"},"fi":{"delete":"Poista tämä vaihtoehto","up":"Siirrä ylös","down":"Siirrä alas"}}')
  delete Component.options._Ctor
}
